import React from 'react'

export const TituloModal = ({titulo}) => {
  return (
    <div className='tituloModal'>{titulo}</div>
  )
}
